import { render, staticRenderFns } from "./ChatWithBadge.vue?vue&type=template&id=ede1d72a"
import script from "./ChatWithBadge.vue?vue&type=script&lang=ts"
export * from "./ChatWithBadge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ede1d72a')) {
      api.createRecord('ede1d72a', component.options)
    } else {
      api.reload('ede1d72a', component.options)
    }
    module.hot.accept("./ChatWithBadge.vue?vue&type=template&id=ede1d72a", function () {
      api.rerender('ede1d72a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/viewer/ChatWithBadge.vue"
export default component.exports